import * as diff from "diff";

export const mark_differences = (string1 = "", string2 = "") => {
  const lines1 = string1.split('\n');
  const lines2 = string2.split('\n');

  // Create an array to hold the marked differences
  const markedDifferences = [];

  // Loop through the lines to handle diffs line by line
  const maxLength = Math.max(lines1.length, lines2.length);
  for (let i = 0; i < maxLength; i++) {
    const line1 = lines1[i] || ""; // Handle cases where one string is longer
    const line2 = lines2[i] || "";

    let groups = diff.diffWords(line1, line2);
    const mappedNodes = groups.map(group => {
      const { value, added, removed } = group;
      if (added) {
        return `@@color(success)${value}@@`;
      } else if (removed) {
        return `@@color(danger)${value}@@`;
      } else {
        return value;
      }
    });

    // Join the differences for this line and add a newline character
    markedDifferences.push(mappedNodes.join(""));
  }

  // Join all lines with newline characters preserved
  return markedDifferences.join('\n');
};